export enum CreatureTypeIds {
    Character = 0,
    AnimalCompanion = 1,
    Familiar = 2,
}
